export default "__VITE_ASSET__RyIR_4YD__"